import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import { observer, inject } from 'mobx-react'
import * as styles from './style/index.scss'
import { InputItem, Button, WhiteSpace, Checkbox } from 'antd-mobile'
import intl from '@utils/intl'
import { FormattedMessage } from 'react-intl'
import LoginBg from '@assets/img/global/global-login-bg.png'
import { Redirect } from 'react-router-dom'
import LangSwitch from '@componentsG/switchLang'
import { isEmail } from '@src/utils';
import { userStore } from '@src/store/userStore'
import bannerIcon from '@assets/img/login/bannerIcon.png'
import { TRYBUY_EVENT_TRACING_PAGE, TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
const CheckboxItem = Checkbox.AgreeItem;
@inject('loginStoreG', 'homeStoreG')
@observer
class Login extends ComponentExt<any, any> {
    private store: any
    private homeStoreG: any
    private email: any
    private password: any
    private emailPlaceHolder = intl.formatMessage({ id: 'login.input.email' })
    private passwordPlaceHolder = intl.formatMessage({ id: 'login.input.password' })
    private registerTip = intl.formatMessage({ id: 'login.tip.noAccount' })
    private noInfo = intl.formatMessage({ id: 'login.check.noInfo' })
    private errorEmail = intl.formatMessage({ id: 'register.check.errorEmail' })

    constructor(props) {
        super(props)
        this.store = props.loginStoreG
        this.homeStoreG = props.homeStoreG
        this.state = {
            userInfo: null,
            checkBox: false,
            operatorId: null
        }
    }

    async componentDidMount() {
        const url = location.href.split('?iccid=')[1]
        const iccid = url.split('&')[0]
        if (iccid) {
            this.setState({
                operatorId: await this.homeStoreG.getOperatorId(iccid)
            })
        }
        this.setState({
            userInfo: await this.homeStoreG.getUserInfo()
        })
        userStore.sendEventTracing({
            pageCode: TRYBUY_EVENT_TRACING_PAGE.TRYBUY_PAGE_LOGIN,
            buttonCode: '',
            buttonInfo: ''
        })
    }

    handleLogin = () => {
        if (!this.email.state.value || !this.password.state.value) {
            this.$toast.info(this.noInfo)
            return false
        } else if (!isEmail(this.email.state.value)) {
            this.$toast.info(this.errorEmail)
            return false
        } else if (localStorage.getItem('chl') === 'tabletApp' && this.state.operatorId !== 20 && !this.state.checkBox) {
            this.$toast.info(intl.formatMessage({ id: 'login.terms' }))
            return false
        } else {
            this.store.handleLogin(this.email.state.value, this.password.state.value)
            userStore.sendEventTracing({
                pageCode: '',
                buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_LOGIN,
                buttonInfo: ''
            })
        }
    }
    checkboxChange = (e) => {
        this.setState({ checkBox: e.target.checked })
    }
    render() {
        if (!!this.state.userInfo && !!this.state.userInfo.lenovoId) {
            return <Redirect to={'/global/home'} />
        }
        const chl = localStorage.getItem('chl')
        return (
            <div className={styles.loginOutWrap}>
                <div style={{ position: 'absolute', right: 15, top: 15, zIndex: 99 }}>
                    <LangSwitch className={styles.switchLangWrap} white />
                </div>
                <div style={{ position: 'relative' }}>
                    <img src={LoginBg} style={{ width: '100%', minHeight: '194px' }} />
                    {
                        chl === 'tabletApp' && <div className={styles.bannerText}>
                            <h2>{intl.formatMessage({ id: this.state.operatorId !== 20 ? 'login.banner.flow' : 'login.banner.VFflow' })}</h2>
                            {/* <img src={bannerIcon} />
                            <span>{intl.formatMessage({ id: 'login.banner.coming' })}</span> */}
                            {/* <span>{intl.formatMessage({ id: 'login.banner.size' })}</span> */}
                        </div>
                    }
                </div>
                <div className={styles.loginWrap}>
                    <h4 className={styles.loginTitle}>
                        <FormattedMessage id="login.loginText" />
                    </h4>
                    <InputItem
                        placeholder={this.emailPlaceHolder}
                        className={styles.inputItem}
                        clear
                        ref={el => this.email = el}
                    />
                    <WhiteSpace className={styles.whiteSpace} />
                    <InputItem
                        type={'password'}
                        placeholder={this.passwordPlaceHolder}
                        clear
                        className={styles.inputItem}
                        ref={el => this.password = el}
                    />
                    <p className={styles.registerTip}>
                        <span style={{ color: '#eb6a1a' }} onClick={() => window.open(`https://passport.lenovo.com/wauthen2/gateway?lenovoid.action=resetpassword&lenovoid.lang=en-US`)}>
                            <FormattedMessage id="login.tip.forget" />
                        </span>
                    </p>
                    <Button
                        className={styles.loginBtn}
                        onClick={this.handleLogin}
                    >
                        <FormattedMessage id="login.loginText" />
                    </Button>
                    <p className={styles.registerTip}>{this.registerTip}
                        <span onClick={() => this.goToPath('/global/sign-up')}>
                            <FormattedMessage id="login.tip.toRegister" />
                        </span>
                    </p>
                    <p className={styles.registerTip} style={{ textAlign: 'left' }}>
                        {chl === 'tabletApp' && this.state.operatorId !== 20 &&
                            <CheckboxItem onChange={this.checkboxChange}>
                                <FormattedMessage
                                    id="register.tipForTablet"
                                    values={{
                                        a1: chunks => <span
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() => this.goToPath(`/global/active-detail`)}
                                        >
                                            {chunks}
                                        </span>,
                                        a2: chunks => <span
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() => window.open('https://www.lenovoconnect.com/en/service/UEM/try-conditions')}
                                        >
                                            {chunks}
                                        </span>,
                                        a3: chunks => <span
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() => window.open('https://www.ckh.com.hk/en/global/tnc.php')}
                                        >
                                            {chunks}
                                        </span>,
                                        a4: chunks => <span
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() => window.open('https://www.lenovoconnect.com/en/service/UEM/try-privacy')}
                                        >
                                            {chunks}
                                        </span>,
                                        a5: chunks => <span
                                            style={{ textDecoration: 'underline' }}
                                            onClick={() => window.open('https://www.ckh.com.hk/en/global/privacy.php')}
                                        >
                                            {chunks}
                                        </span>,
                                    }}
                                />
                            </CheckboxItem>
                        }
                    </p>
                </div>
            </div>
        )
    }
}

export default Login
